module.exports = __webpack_public_path__ + "static/img/dashboardMain.a6e7864.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/dashboardMain.png
// module id = vMfs
// module chunks = 1